<template>
  <div class="cart-page">
      <Header />
      <SmoothScroll>
         <PageTitle :pageTitle="'კალათა'" :titleColor="'#044B30'" />
          <div class="full-cont cartContainer">
            <div class="box">
              ASDASD
              <CartItem />
              <CartItem />
            </div>
            <div class="box"></div>
          </div>
        <Footer />
      </SmoothScroll>
  </div>
</template>

<script>
import SmoothScroll from '@/components/SmoothScroll';
import CartItem from '@/components/CartItem.vue';
import PageTitle from '@/components/layout/PageTitle';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
export default {
components: {SmoothScroll, Header, PageTitle, Footer, CartItem },
data() {
  return {

  }
}
}
</script>

<style>
.cart-page .full-cont .icon {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cart-page .full-cont {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 334px;
}
.cart-page .full-cont .box {
  border-bottom: 1px solid #D7DEED;
  border-radius: 50%s;
}
.cart-page .full-cont .box:first-child {
  width: 665px;
}
.cart-page .full-cont .box:first-child .cart-item {
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  padding-bottom: 20px;
  align-items: center;
  position: relative;
}
.cart-page .full-cont .box:first-child .cart-item::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #D7DEED;
}
.cart-page .full-cont .box:first-child .cart-item .inner {
  display: flex;
  align-items: center;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child {
  align-items: flex-start;
}
.cart-page .full-cont .box:first-child .cart-item .inner:first-child .item:nth-child(1) {
  margin-right: 10px;
}
.cart-page .full-cont .box:first-child .cart-item .item:nth-child(1) input {
  width: 24px;
  height: 24px;
  border: 1px solid red;
  cursor: pointer;
}
.cart-page .full-cont .box:first-child .cart-item .inner:first-child .item:nth-child(2) {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid;
  width: 95px;
  flex: none;
  margin-right: 21px;
  height: 130px;
}
.cart-page .full-cont .box:first-child .cart-item .inner:first-child  .item:nth-child(2) img {
  max-width: 95px;
  max-height: 130px;
}
.cart-page .full-cont .box:first-child .cart-item .item:nth-child(3) {

}
.cart-page .full-cont .box:first-child .cart-item .item:nth-child(3) .title {
  font-size: 21px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  color: #BACB32;
  overflow: hidden;
  padding-right: 10px;
  width: 250px;
}
.cart-page .full-cont .box:first-child .cart-item .item:nth-child(3) .size,
.cart-page .full-cont .box:first-child .cart-item .item:nth-child(3) .size span {
  font-size: 16px;
}
.cart-page .full-cont .box:first-child .cart-item .item:nth-child(3) .size {
  color: #707479;
}
.cart-page .full-cont .box:first-child .cart-item .item:nth-child(3) .size span {
  color: #101820;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(1) {
  display: flex;
  align-items: center;
  margin-right: 85px;
  flex: none;
} 
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(2) {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  flex: none;
  position: relative;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(1) button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(1) button:first-child {
  margin-right: 21px;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(1) .counter {
  margin-right: 21px;
  font-size: 21px;
  color: #BACB32;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(2) .price {
  font-size: 21px;
  color: #BACB32;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(2) .disable-price {
  position: absolute;
  top: -20px;
  right: 0;
  font-size: 16px;
  color: #101820;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(2) .disable-price::after {
  content: "";
  width: 100%;
  position: absolute;
  left: 0;
  height: 1px;
  top: 50%;
  transform: translateY(-50%);
  background-color: black;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(2) button {
  display: flex;
  align-items: center;
  margin-top: 15px;
  transition: 0.6s;
  justify-content: flex-end;
}
.cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(2) button span {
  font-size: 16px;
  color: #101820;
  margin-right: 2px;
}
.cart-page .full-cont .box:last-child {
  margin-left: 95px;
  width: 350px;
}

/* for Hover animation */
@media (min-width: 1024px) {
  .cart-page .full-cont .box:first-child .cart-item .inner:last-child .item:nth-child(2) button:hover {
    transform: scale(1.1) rotate(5deg);
  }
}
/* for Hover animation */

/* Responsive design */
@media (max-width: 1900px) {

}
@media (max-width: 1679px) {
  
}
@media (max-width: 1365px) {
  
}
@media (max-width: 1023px) {
  
}
@media (max-width: 767px) {
  
}
/* Responsive design */
</style>